import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';

import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import ConfirmActionModal from '../Common/confirmActionModal';
import { DateFormatter } from '../Common/dateFormat';
import CashFormatter from '../Common/cashFormatter';
import SpinnerButton from '../Common/SpinnerButton';
import PrintIframe from '../Common/PrintIframe';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import checkPermission from '../Common/permissions';
import { dateFormat, toFromDates } from '../Common/cleanDates';

import { ROOT_URL, companyCodeTitle, isOCM, isVAK, isSV, isHO, isOLG, isCPG, isVIP, isLMH, isTQ } from '../../actions/root_url';

class PurchaseReturnList extends Component {
    static contextTypes = {
      router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage,

        createOpen: false,

        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,

        returnPDFFrameLoaded: true,

        checkAuthorizeOpen: false,
        action: null,
        syncModalVisibility: false,
        syncMsg: '',
        days: '7',
        fromDate: undefined,
        toDate: undefined,
        filteredByItem: false,
        status: 'all',
        returnPdfFrameLoadedNs: true,
      };

        this.handleResize = this.handleResize.bind(this);
        this.openCreate = this.openCreate.bind(this);
        this.closeCreate = this.closeCreate.bind(this);
        this.checkAuthorize = this.checkAuthorize.bind(this);
        this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
        this.closeSyncVisibility = this.closeSyncVisibility.bind(this);
        this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    }

    componentDidMount() {
        document.title = companyCodeTitle;
        window.addEventListener('resize', this.handleResize);
        this.refreshList()
      }

    componentDidUpdate(prevProps) {
      if (prevProps.selectedWarehouse !== this.props.selectedWarehouse) {
        this.refreshList()
      }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage});
    }

    // Once products are ready, reset state..

    componentWillReceiveProps(nextProps) {
      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
        this.closeCheckAuthorize();
        if (this.state.action === 'void') {
          this.voidPurchaseReturn();
        }
      }
        if (nextProps.purchaseReturns && nextProps.purchaseReturns != this.props.purchaseReturns) {
            let purchaseReturns = nextProps.purchaseReturns;
            purchaseReturns.map(purchaseReturn => {
              purchaseReturn['Name'] = purchaseReturn.Vendor_id.Name;
            })
            this.setState({
                rows: purchaseReturns
            });
        }

        if (nextProps.purchaseReturnPdf && nextProps.purchaseReturnPdf !== this.props.purchaseReturnPdf) {
          this.setState({ returnPDFFrameLoaded: false });
        }

        if (nextProps.purchaseReturnPdfNs && nextProps.purchaseReturnPdfNs !== this.props.purchaseReturnPdfNs) {
          this.setState({ returnPdfFrameLoadedNs: false });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.returnPDFFrameLoaded !== this.state.returnPDFFrameLoaded && this.state.returnPDFFrameLoaded == false) {
        return false;
      }
      if (nextState.returnPdfFrameLoadedNs !== this.state.returnPdfFrameLoadedNs && this.state.returnPdfFrameLoadedNs == false) {
        return false;
      }

      return true;
    }

    openCreate() { this.setState({ createOpen: true }); }
    closeCreate() { this.setState({ createOpen: false }); }

    checkAuthorize(password) {
      this.props.checkPassword(password);
    }

    openCheckAuthorize(action) {
      this.props.clearCheckPassword();
      this.setState({ checkAuthorizeOpen: true, action });
    }

    closeSyncVisibility() {
      this.setState({ syncModalVisibility: false });
    }

    closeCheckAuthorize() {
      this.setState({ checkAuthorizeOpen: false });
    }

    voidPurchaseReturn() {
      const purchaseReturnID = (this.state.selectedRows.length) && this.state.selectedRows[0].PurchaseReturn_id;
      this.props.voidPurchaseReturn(purchaseReturnID).then(() => {
        this.refreshList()
      });
    }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseReturn(e) {
        e.preventDefault();
        const currentPurchaseReturn = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseReturn();
        this.props.selectPurchaseReturn(currentPurchaseReturn);
        this.context.router.push('/purchaseReturn/'+currentPurchaseReturn.PurchaseReturn_id);
    }

    createPurchaseReturn(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseReturn();
        this.context.router.push('/purchaseReturn/new');
    }

    createPurchaseCredit(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseReturn();
        this.context.router.push('/purchaseReturn/newCredit');
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseReturn();
        this.context.router.push('/purchaseReturn/new')
    }

    handlePrintFrameOnLoad = () => {
      this.setState({ returnPDFFrameLoaded: true });
    }

    handlePrintFrameNsOnLoad = () => {
      this.setState({ returnPdfFrameLoadedNs: true });
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><br /><br /><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 560 : 560;

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'PRNum',
                    name: <Translate value="return_no" />,
                    resizable: true,
                    sortable: true,
                    width: 105,
                    filterable: true,
                },
                {
                    key: 'Name',
                    name: <Translate value="vendor_name" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                },
                {
                    key: 'ReturnReason',
                    name: <Translate value="return_reason" />,
                    resizable: true,
                    sortable: true,
                    width: 150,
                    filterable: true,
                },
                {
                    key: 'ReturnStatus',
                    name: <Translate value="return_status" />,
                    resizable: true,
                    sortable: true,
                    width: 150,
                    filterable: true,
                },
              ...isVAK ? [{
                key: 'Review_Status',
                name: <Translate value="review_status" />,
                width: 150,
              }, {
                key: 'Approve_Status',
                name: <Translate value="approve_status" />,
                width: 150,
              }] : [],
                {
                  key: 'IsFinalized',
                  name: <Translate value="is_finalized" />,
                  resizable: true,
                  sortable: true,
                  width: 150,
                  filterable: true,
                  formatter: (props) => {
                    return (
                      <div>{props.value ? 'yes': 'no'}</div>
                    )
                  }
                },
                ...(isCPG || isVIP || isLMH || isTQ) ? [{
                  key: 'SyncStatus',
                  name: <Translate value="qb_sync" />,
                  resizable: true,
                  width: 100,
                  sortable: true,
                  filterable: true,
                }] : [],
                ...(isCPG || isVIP || isLMH || isTQ) ? [{
                  key: 'QBError',
                  name: <Translate value="qb_msg" />,
                  resizable: true,
                  width: 100,
                  sortable: true,
                  filterable: true,
                getRowMetaData: (row) => row,
                  formatter: ({dependentValues}) => {
                    return (
                      <div style={{cursor: 'pointer'}} onClick={() => this.setState({syncModalVisibility: true, syncMsg: dependentValues.QBError})}>{(dependentValues.SyncStatus !== 'Synced') ? dependentValues.QBError : ''}</div>
                    )
                  }
                }] : [],
                {
                    key: 'FinalPrice',
                    name: <Translate value="final_dollarsign" />,
                    resizable: true,
                    sortable: true,
                    width: 105,
                    filterable: true,
                    formatter: CashFormatter,
                },
                {
                    key: 'MemoNum',
                    name: <Translate value="memo_poundsign" />,
                    resizable: true,
                    sortable: true,
                    width: 150,
                    filterable: true,
                },
                ...isOLG ? [{
                  key: 'PostingDate',
                  name: <Translate value="return_date" />,
                  resizable: true,
                  sortable: true,
                  width: 115,
                  filterable: true,
                  formatter: DateFormatter
                }] : [],
                {
                    key: 'CreateTime',
                    name: <Translate value="created" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true,
                    formatter: DateFormatter
                }
            ]

            let cTemp = [];
            if (this.state.rows && this.state.rows.length > 0) {
              this.state.rows.map((r,i) => {
                if (r.SyncStatus === 0) {
                  cTemp.push({...r, SyncStatus: 'Unsynced'});
                } else if (r.SyncStatus === 1) {
                  cTemp.push({...r, SyncStatus: 'Synced'});
                } else if (r.SyncStatus === 2) {
                  cTemp.push({...r, SyncStatus: 'Failed'});
                } else {
                  cTemp.push({...r});
                }
              });
              this.state.rows = cTemp;
            }

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="PurchaseReturnList-dataGrid1">
                    <ReactDataGrid
                        rowKey='PurchaseReturn_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={tableHeight}
                        enableRowSelect='multi'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    renderPrintIframe() {
      const { returnPDFFrameLoaded } = this.state;
      const { purchaseReturnPdf } = this.props;
      return (
        <PrintIframe
          id="returnPDF"
          loaded={returnPDFFrameLoaded}
          name="returnPDF"
          onLoad={this.handlePrintFrameOnLoad}
          pdf={purchaseReturnPdf}
          title={<Translate value="print_purchase_return" />}
        />
      );
    }

    renderPrintNsIFrame() {
      const { returnPdfFrameLoadedNs } = this.state;
      const { purchaseReturnPdfNs } = this.props;
      return (
        <PrintIframe
          id="returnNsPdf"
          loaded={returnPdfFrameLoadedNs}
          name="returnNsPDF"
          onLoad={this.handlePrintFrameNsOnLoad}
          pdf={purchaseReturnPdfNs}
          title={<Translate value="print_purchase_return_no_$" />}
        />
      );
    }

    checkPermission(permission) {
        return false;
    }

    setToDate = (e) => {
      if (e < this.state.fromDate) {
        return;
      }
      this.setState({ toDate: e });
    }

    setFromDate = (e) => {
      if (e > this.state.toDate) {
        return;
      }
      this.setState({ fromDate: e });
    }

    setToRangeSearch = (e) => {
      this.setState({ days: '-1' });
    }

    handleStatusFilterChange = (status) => {
      const route = this.context.router.routes[1].path;
      const { days, fromDate, toDate } = this.state;
      this.setState(
        { status: status },
        () => { this.refreshList() },
      );
    }

    handleDaysFilterChange = (days) => {
      const route = this.context.router.routes[1].path;
      const { fromDate, toDate, status } = this.state;
      this.setState(
        { days: days },
        () => { this.refreshList() },
      );
    }

    getExcelUrl() {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      let returnStatusString = `ReturnStatus=${this.state.status}`;
      if (this.state.fromDate) {
        fromDate = dateFormat('YYYY-MM-DD', this.state.fromDate);
      }
      if (this.state.toDate) {
        toDate = dateFormat('YYYY-MM-DD', this.state.toDate);
      }
      const dates = toFromDates(this.state.days, fromDate, toDate);
      // if "all" status is selected, dont pass a ReturnStatus
      if (this.state.status === 'all') {
        returnStatusString = '';
      }
      const currentPurchaseReturnRows = this.state.selectedRows;
      const idsSelect = []
      if(currentPurchaseReturnRows.length){
        currentPurchaseReturnRows.map(item => {
          idsSelect.push(item.PurchaseReturn_id)
        })
      }
      const idsData = idsSelect.join(',');
      if(isVAK || isHO){
        if(currentPurchaseReturnRows.length){
          return `${ROOT_URL}v1/purchase/return/excel/${idsData}?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}&${returnStatusString}&Bearer=${localStorage.getItem('token')}`;
        }
      }
      return `${ROOT_URL}v1/purchase/return/excel/?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}&${returnStatusString}&Bearer=${localStorage.getItem('token')}`;
    }

    getExcelDetailsUrl = () => {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      let returnStatusString = `ReturnStatus=${this.state.status}`;
      let selectedCompany = '';
      let selectedWarehouse = '';
      if (this.props.selectedCompany) {
        selectedCompany = `&companyId=${this.props.selectedCompany.value}`
      }
      if (this.props.selectedWarehouse) {
        selectedWarehouse = `&warehouseId=${this.props.selectedWarehouse.value}`
      }
      if (this.state.fromDate) {
        fromDate = dateFormat('YYYY-MM-DD', this.state.fromDate);
      }
      if (this.state.toDate) {
        toDate = dateFormat('YYYY-MM-DD', this.state.toDate);
      }
      const dates = toFromDates(this.state.days, fromDate, toDate);
      // if "all" status is selected, dont pass a ReturnStatus
      if (this.state.status === 'all') {
        returnStatusString = '';
      }
      const currentPurchaseReturnRows = this.state.selectedRows;
      const idsSelect = []
      if(currentPurchaseReturnRows.length){
        currentPurchaseReturnRows.map(item => {
          idsSelect.push(item.PurchaseReturn_id)
        })
      }
      const idsData = idsSelect.join(',');
      if(isVAK){
        if(currentPurchaseReturnRows.length){
          return `${ROOT_URL}v1/purchase/return/line_details/${idsData}?startDate=${dates.fromDate}&endDate=${dates.toDate}${selectedCompany}${selectedWarehouse}&Bearer=${localStorage.getItem('token')}`;
        }
      }
      let selectedIds = isHO && idsData ? `&ids=${idsData}` : ''
      return `${ROOT_URL}v1/purchase/return/line_details/?startDate=${dates.fromDate}&endDate=${dates.toDate}${selectedCompany}${selectedWarehouse}&Bearer=${localStorage.getItem('token')}${selectedIds}`;
    }

    checkIfSelectedCantBeFinalized = () => {
      const {
        selectedRows,
      } = this.state;
      let cantBeFinallized = false;
      if (!selectedRows.length) return true;
      selectedRows.forEach(row => {
        if (isVAK) {
          if (row.Review_Status !== 'Confirm' || row.Approve_Status !== 'Confirm' || row.IsFinalized || !checkPermission("finalize_pr")) {
            cantBeFinallized = true;
          }
        } else {
          if (row.IsFinalized) {
            // alert(`${row.PRNum} has already been finalized`);
            cantBeFinallized = true;
          }
        }
      })

      return cantBeFinallized;
    };

    finalizeSelectedReturns = () => {
      const {
        selectedRows,
      } = this.state;
      const ids = selectedRows.map(r => r.PurchaseReturn_id);

      const success = () => {
        alert('success');
        this.refreshList();
      }
      const failed = () => {
        alert('failed');
      }
      this.props.finalizeSelectedReturns(ids.join(','), success, failed)
    }

    refreshList = () => { 
      this.setState({
        selectedRows: [],
      })
      this.props.fetchPurchaseReturns(this.state.fromDate, this.state.toDate, this.state.days, this.state.status);
    }

    checkFinalizeStatus = () => {
      // const selectedRows = this.state.selectedRows;
      // if (selectedRows.length && selectedRows[0].IsFinalized) {
      //   return true
      // }
      return false
    }

    renderSyncToQB = () => {
      const {
        selectedRows,
      } = this.state;
      const receive_ids = _.map(selectedRows, row => row.PurchaseReturn_id).join(',');
      const enabled = () => {
        if (checkPermission("set_released_sales_invoice") && selectedRows.length) {
          return true;
        }
        return false;
      }
      return (
        <Button
          bsStyle="success"
          onClick={() => {
            this.props.syncPurchaseReturnToQB(receive_ids);
          }}
          disabled={!enabled()}
        >
          <Translate value="sync_to_QB" />
        </Button>
      )
    }
    
    renderRestock() {
      const { selectedRows} = this.state;
      const handleRestock = (id) => {
        axios({
          method: 'post',
          url:  `${ROOT_URL}v1/purchase/return/restock/${id}`,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then(res => {
          alert('success');
          this.refreshList();
        })
        .catch(err => {
          alert(JSON.stringify(err.data));
        })
      }
      return (
        <Button
          bsStyle="success"
          onClick={() => {
            handleRestock(selectedRows[0].PurchaseReturn_id);
          }}
          disabled={selectedRows.length !== 1 || selectedRows[0].ReturnStatus === 'Void'}
        >
          <Translate value="restock" />
        </Button>
      )
    }

    render() {
      const createDialogStyle = {
        width: '550px',
        height: '300px',
        marginLeft: '-15%',
      };
        let height = (this.state.tableHeight + 140).toString();
        let tableCollapseFix = { height: height}
        const purchaseReturnID = (this.state.selectedRows.length) && this.state.selectedRows[0].PurchaseReturn_id;
        let voidButtonShouldDisable = !this.state.selectedRows.length || this.state.selectedRows.length !== 1 ||
          this.props.purchaseReturnIsVoiding || this.state.selectedRows[0].ReturnStatus !== 'Open';
        if(isVAK){
          voidButtonShouldDisable = !this.state.selectedRows.length || this.state.selectedRows.length !== 1 ||
          this.props.purchaseReturnIsVoiding || this.state.selectedRows[0].ReturnStatus === 'Void';
        }
        // const printUrl = `${ROOT_URL}v1/purchase/return/print/${PurchaseReturn_id}/?Bearer=${localStorage.getItem('token')}`;
        return (
          //---------------
          // Begin HTML
          //---------------
          <ContentWrapper>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="purchase_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="purchase_return" />
              </Breadcrumb.Item>
            </Breadcrumb>

            <Grid id="purchase-return-list">

              <Row>
                <Col xs={12}>
                  <Panel id="date-range-picker" className="form-horizontal">
                    <Row>
                      <Col xs={2}>
                        <h3 className="filter-title"><Translate value="return_status" /><span className="colon">:</span></h3>
                      </Col>
                      <Col xs={10}>
                        <div id="statusFilterRadios" className="form-horizontal">
                          {
                            genericRadioFilter({
                              content: [
                                {
                                    option: 'all',
                                    id: 'all-radio-filter',
                                    name: 'statusFilterRadios',
                                    labelName: 'all',
                                },
                                {
                                    option: 'Open',
                                    id: 'open-radio-filter',
                                    name: 'statusFilterRadios',
                                    labelName: 'open',
                                },
                                {
                                    option: 'Void',
                                    id: 'void-radio-filter',
                                    name: 'statusFilterRadios',
                                    labelName: 'void',
                                },
                                {
                                    option: 'Completed',
                                    id: 'completed-radio-filter',
                                    name: 'statusFilterRadios',
                                    labelName: 'completed',
                                },
                              ],
                              value: this.state.status,
                              handleOnClick: this.handleStatusFilterChange,
                              type: 'buttons',
                            })
                          }
                        </div>
                      </Col>
                      <Col xs={2}>
                        <h3 className="filter-title"><Translate value="return_date" /><span className="colon">:</span></h3>
                      </Col>
                      <Col xs={10}>
                        {
                          dateFilterRadios({
                            handleOnClick: this.handleDaysFilterChange,
                            setFromDate: this.setFromDate,
                            setToDate: this.setToDate,
                            setToRangeSearch:this.setToRangeSearch,
                            FromDate: this.state.fromDate,
                            ToDate: this.state.toDate,
                            Days: this.state.days,
                          })
                        }
                      </Col>
                    </Row>
                  </Panel>
                </Col>
              </Row> {/* End Date Range Picker */}

              <Row>
                <Col xs={12}>
                  <Panel className="position-relative table-collapse-fix">
                    <ButtonToolbar className="table-buttons">
                      <Button
                        bsStyle="success"
                        type="submit"
                        onClick={(event) => { this.createPurchaseReturn(event); }}
                        disabled={!checkPermission('add_purchase_return')}
                      >
                        <em className="fa fa-plus" /><Translate value="create_purchase_return" />
                      </Button>
                      <Button
                        bsStyle="success"
                        type="submit"
                        onClick={(event) => { this.createPurchaseCredit(event); }}
                        disabled={!checkPermission('add_purchase_return')}
                      >
                        <em className="fa fa-plus" /><Translate value="receive_credit" />
                      </Button>
                      <Button
                        bsStyle="success"
                        // href={this.getExcelUrl()}
                        disabled={this.checkIfSelectedCantBeFinalized()}
                        onClick={this.finalizeSelectedReturns}
                      >
                        <em className="fa fa-file" /><Translate value="finalize" />
                      </Button>
                      <Button
                        bsStyle="warning"
                        type="button"
                        onClick={(event) => { this.setCurrentPurchaseReturn(event); }}
                        disabled={(!this.state.selectedRows || this.state.selectedRows.length !== 1) || !checkPermission('change_purchase_return') || this.checkFinalizeStatus()}
                      >
                        <em className="fa fa-pencil" /><Translate value="edit" />
                      </Button>
                      <SpinnerButton
                        bsStyle="danger"
                        disabled={voidButtonShouldDisable || !checkPermission('delete_purchase_return') || this.checkFinalizeStatus()}
                        icon="fa-trash"
                        translation={<Translate value="void" />}
                        loading={this.props.purchaseReturnIsVoiding}
                        onClick={() => { this.openCheckAuthorize('void'); }}
                      />
                      <SpinnerButton
                        bsStyle="primary"
                        disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || this.props.requestingPurchaseReturnPdf || !checkPermission('print_purchase_return')}
                        icon="fa-print"
                        translation={<Translate value="print" />}
                        loading={this.props.requestingPurchaseReturnPdf}
                        onClick={() => {
                          this.props.printPurchaseReturn(purchaseReturnID);                        
                        }}
                      />
                      <SpinnerButton
                        bsStyle="primary"
                        disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || this.props.requestingPurchaseReturnPdf || !checkPermission('print_purchase_return')}
                        icon="fa-print"
                        translation={<Translate value="print_ns" />}
                        loading={this.props.requestingPurchaseReturnPdf}
                        onClick={() => {
                          this.props.printPurchaseReturnNoSubtotals(purchaseReturnID);

                        }}
                      />
                      <Button
                        bsStyle="success"
                        href={this.getExcelUrl()}
                        disabled={!this.state.rows.length || !checkPermission('print_purchase_return')}
                      >
                        <em className="fa fa-download" /><Translate value="excel" />
                      </Button>
                      <Button
                        bsStyle="success"
                        href={this.getExcelDetailsUrl()}
                        disabled={!this.state.rows.length || !checkPermission('print_purchase_return')}
                      >
                        <em className="fa fa-download" /><Translate value="excel_details" />
                      </Button>
                      {this.renderSyncToQB()}
                      { isSV && this.renderRestock()}
                    </ButtonToolbar>
                    {this.renderTable()}
                  </Panel>
                </Col>
              </Row>
            </Grid>
            {this.renderPrintIframe()}
            {this.renderPrintNsIFrame()}
            <SkyLightStateless
              dialogStyles={createDialogStyle}
              isVisible={this.state.checkAuthorizeOpen}
              onCloseClicked={this.closeCheckAuthorize}
            >
              <ConfirmActionModal
                case="confirmPassword"
                closeC={this.checkAuthorize}
                checkPasswordFailure={this.props.checkPasswordFailure}
              />
            </SkyLightStateless>
            <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.syncModalVisibility}
            onCloseClicked={this.closeSyncVisibility}
          >
           <p style={{fontSize: '13px'}}>
              {this.state.syncMsg}
           </p>
          </SkyLightStateless>
          </ContentWrapper>
          //---------------
          // End HTML
          //---------------
        );
    }
}

// <Row>
//                     <Button
//                         bsStyle="primary"
//                         style={{ marginLeft: '20px' }}
//                         onClick={this.openCreate}>
//                         <em className="fa fa-plus" style={{marginRight: "10px"}}/>Add Purchase Return
//                     </Button>
//                     <Button
//                         bsStyle="primary"
//                         style={{ marginLeft: '20px' }}
//                         onClick={(event) => { this.setCurrentPurchaseReturn(event) } }
//                         disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
//                         <em className="fa fa-pencil" style={{marginRight: "10px"}}/>Edit Purchase Return
//                     </Button>
//                 </Row>
//                 <br/>
//                 {this.renderTable() }


export default PurchaseReturnList;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseReturnList.jsx